import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import AsyncStorage from '@react-native-async-storage/async-storage';
import type { TradeRole, TradeSession } from '../features/trade/types';

type TradeModalIntent =
  | { kind: 'home' }
  | { kind: 'join'; prefilledCode?: string }
  | { kind: 'share' }
  | { kind: 'guest_web'; token: string };

type TradeStore = {
  activeSessionId: string | null;
  role: TradeRole | null;
  session: TradeSession | null;
  modalIntent: TradeModalIntent | null;
  setActive: (sessionId: string, role: TradeRole) => void;
  setSession: (session: TradeSession | null) => void;
  openModal: (intent?: TradeModalIntent) => void;
  closeModal: () => void;
  clear: () => void;
};

export const useTradeStore = create<TradeStore>()(
  persist(
    (set) => ({
      activeSessionId: null,
      role: null,
      session: null,
      modalIntent: null,
      setActive: (sessionId, role) => set({ activeSessionId: sessionId, role }),
      setSession: (session) => set({ session }),
      openModal: (intent = { kind: 'home' }) => set({ modalIntent: intent }),
      closeModal: () => set({ modalIntent: null }),
      clear: () => set({ activeSessionId: null, role: null, session: null }),
    }),
    {
      name: 'cambiafiguritas-trade-v1',
      storage: createJSONStorage(() => AsyncStorage),
      // Persisto sólo lo que sirve para resumir el flujo: modalIntent (modal
      // abierto), activeSessionId + role (en qué sesión estaba). 'session' no se
      // persiste porque viene en tiempo real de Firestore vía useTradeSession.
      partialize: (state) => ({
        modalIntent: state.modalIntent,
        activeSessionId: state.activeSessionId,
        role: state.role,
      }),
    },
  ),
);
